const initialState = {
  uspList: null,
  uspById: null,
};

const propertyUspReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_PROPERTY_USP":
      return {
        ...state,
        uspList: action.data,
      };
    case "GET_PROPERTY_USP_BY_ID":
      return {
        ...state,
        uspById: action.data,
      };
    case "ADD_PROPERTY_USP":
      return {
        ...state,
      };
    case "UPDATE_PROPERTY_USP_BY_ID":
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default propertyUspReducer;
